import {getToken, setToken, removeToken} from '@/utils/auth'
// import router, {resetRouter} from '@/router'
import {login} from '@/api/temporary'
const state = {
  token: getToken(),
  name: '',
  avatar: '',
  introduction: '',
  roles: [],
  user_app: 0,
  userinfo: {},
  rulebtn:[],
  inst_id:'',
  autonym:{}
}
const mutations = {
  SET_RULEBTN: (state, btn) => {
    state.rulebtn = btn
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_UserInfo: (state, userinfo) => {
    state.userinfo = userinfo
  },
  SET_UserAutonym: (state, autonym) => {
    state.autonym = autonym
  },
  SET_InstId: (state, inst_id) => {
    state.inst_id = inst_id
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_USER_APP: (state, user_app) => {
    state.user_app = user_app
  }


}

const actions = {
  // user login
  login({commit}, userInfo) {
    const {username, password} = userInfo
    return new Promise((resolve, reject) => {
      login({username: username.trim(), password: password}).then(response => {
        const {data} = response
        commit('SET_TOKEN', data.userToken)
        setToken(data.userToken)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  SET_InstId({commit}, dd) {
    commit('SET_InstId', dd)
  },
  SETUserInfo({commit}, dd) {
    commit('SET_UserInfo', dd)
  },
  SET_UserAutonym({commit}, dd) {
    commit('SET_UserAutonym', dd)
  },
  // SET_USER_APP
  setcheckApp({commit}, app) {
    commit('SET_USER_APP', app)
  },



  // remove token
  resetToken({commit}) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
